import { render, staticRenderFns } from "./Sottoscrizioni.vue?vue&type=template&id=080a923e&"
import script from "./Sottoscrizioni.vue?vue&type=script&lang=js&"
export * from "./Sottoscrizioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports